import React, { Component } from "react";
import { connect } from "react-redux";
import { TokenActions } from "state/actions/user/TokenActions";

export class Logout extends Component {
  componentDidMount () {
    let {
      history
    } = this.props;

    this.props.doLogout();

    history.push("/");
  }

  render () {
    return (
      <div>
        <h3>Logout</h3>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  doLogout: () => {
    dispatch(TokenActions.logout());
  }
});

Logout = connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);
